import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export type modeloStyleType = {
  id?: string,
  company?: string,
  name: string;
  colorHeader?: string | null;
  fontHeader?: {
    fontFamily?: string | null;
    fontSize?: number | null;
    color?: string | null;
  };
  background?: string | null;
  fontBackground?: {
    fontFamily?: string | null;
    fontSize?: number | null;
    color?: string | null;
  };
  logo?: string | null;
  associatedChecklists?: string[] | null;
  enablePosMessage?: boolean;
  enablePostMessage?: boolean;
  enableLoop?: boolean;
  enableRedirect?: boolean;
  messageBefore?: string | null;
  imageBefore?: string | null;
  messageAfter?: string | null;
  imageAfter?: string | null;
  link?: string | null
};

class checklistStyle {


  create = async (
    body: AuthBodyType,
    modelo: modeloStyleType
  ) => {
    try {
      const data: AxiosResponse = await api.post("/checklistStyle/create", {
        ...body,
        modelo,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  edit = async (
    body: AuthBodyType,
    modelo: modeloStyleType
  ) => {
    try {
      const data: AxiosResponse = await api.post("/checklistStyle/edit", {
        ...body,
        modelo,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  getAll = async (
    body: AuthBodyType,
  ) => {
    try {
      const data: AxiosResponse = await api.post("/checklistStyle/getAll", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };

  delete = async (
    body: AuthBodyType, modeloId: string
  ) => {
    try {
      const data: AxiosResponse = await api.post("/checklistStyle/delete", {
        ...body, modeloId
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        return error.response?.status;
      }
    }
  };
}

export default checklistStyle;
